<template>
  <div class="">
    <div class="row justify-content-center py-5 einblenden1">
      <div class="col-lg-10 grauHintergrund">
        <!-- Handstretchfolie-->
        <div class="row p-2 m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildFolien/Handstretchfolie.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <div class="row">
              <div class="col-lg-8 Artikeltext">
                <h2 class="kachelHeader">Handstretchfolie</h2>
                Unsere Handstretchfolie ist die ideale Lösung zur sicheren und effizienten
                Paletten- und Warensicherung. Sie haftet zuverlässig, ist hoch dehnbar und
                reißfest und sorgt so für Stabilität beim Transport sowie Schutz vor
                Staub, Schmutz und Feuchtigkeit. Die Folie lässt sich leicht per Hand
                verarbeiten, passt sich flexibel an unterschiedlichste Ladungen an und
                spart durch ihre hohe Rückstellkraft Material und Zeit. Ob im Lager,
                Versand oder bei der Kommissionierung – Handstretchfolie bietet eine
                einfache und wirksame Verpackungslösung.
              </div>
              <div class="col-lg-4">
                <span class="kachelText">
                  Folienmaße:
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Länge in Meter:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="hflaenge"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Breite in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="hfbreite"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Stärke in my:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="hfhoehe"
                    />
                  </div>
                  <span class="input-group-text" style="width: 100%" id="basic-addon1"
                    >Kurze Beschreibung</span
                  >
                  <div class="input-group mb-3">
                    <textarea
                      class="form-control"
                      aria-label="With textarea"
                      v-model="hfText"
                    ></textarea>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText" id="basic-addon1">Anzahl</span>
              <input type="number" class="form-control anzahlFeld" v-model="handfolie" />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addHf()"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedhf" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>

        <!-- Maschinenstretchfolie-->
        <div class="row p-2 m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildFolien/Maschinenfolie.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <h2 class="kachelHeader">Maschinenstretchfolie</h2>
            <div class="row">
              <div class="col-lg-8 Artikeltext">
                Unsere Maschinenstretchfolie bietet maximale Effizienz und Sicherheit bei
                der automatisierten Palettensicherung. Sie überzeugt durch hohe
                Reißfestigkeit, exzellente Dehnbarkeit und optimale Haftung, was für eine
                stabile und materialsparende Umwicklung sorgt. Die Folie passt sich
                perfekt an verschiedenste Palettenformen an und schützt zuverlässig vor
                Feuchtigkeit, Staub und Transportschäden. Ideal für den Einsatz in halb-
                und vollautomatischen Wickelmaschinen ist sie die perfekte Lösung für
                industrielle Verpackungsprozesse mit hohem Durchsatz.
              </div>
              <div class="col-lg-4">
                <span class="kachelText">
                  Folienmaße:
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Länge in Meter:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="mflaenge"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Breite in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="mfbreite"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Stärke in my:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="mfhoehe"
                    />
                  </div>
                  <span class="input-group-text" style="width: 100%" id="basic-addon1"
                    >Kurze Beschreibung</span
                  >
                  <div class="input-group mb-3">
                    <textarea
                      class="form-control"
                      aria-label="With textarea"
                      v-model="mfText"
                    ></textarea>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText">Anzahl</span>
              <input
                type="number"
                class="form-control anzahlFeld"
                v-model="maschienenfolie"
              />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addMf()"
                style="z-index: 2; position: relative"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedmf" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>

        <!-- Luftpolsterfolie-->
        <div class="row p-2 m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildPolstermaterial/Polsterfolie.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <div class="row">
              <div class="col-lg-8 Artikeltext">
                <h2 class="kachelHeader">Luftpolsterfolie</h2>
                Unsere Luftpolsterfolie bietet zuverlässigen Schutz für empfindliche
                Produkte während Transport und Lagerung. Die Luftpolster wirken
                stoßdämpfend und verhindern Kratzer, Brüche oder andere Transportschäden.
                Sie ist leicht, flexibel und einfach in der Handhabung – ideal zum
                Einwickeln, Ausfüllen oder Auspolstern verschiedenster Waren. Ob für Glas,
                Elektronik, Keramik oder andere sensible Güter: Mit unserer Polsterfolie
                sorgen Sie für eine sichere und professionelle Verpackungslösung.
              </div>
              <div class="col-lg-4">
                <span class="kachelText">
                  Folienmaße:
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Länge in Meter:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="vplaenge"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Breite in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="vpbreite"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Stärke in mm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="vphoehe"
                    />
                  </div>
                  <span class="input-group-text" style="width: 100%" id="basic-addon1"
                    >Kurze Beschreibung</span
                  >
                  <div class="input-group mb-3">
                    <textarea
                      class="form-control"
                      aria-label="With textarea"
                      v-model="vpText"
                    ></textarea>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText" id="basic-addon1">Anzahl</span>
              <input
                type="number"
                class="form-control anzahlFeld"
                v-model="polsterfolie"
              />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addPf()"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedPf" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { anfragenStore } from "@/stores/AnfrageStore";
export default {
  name: "balkenMitBildPaletten",
  data() {
    return {
      vplaenge: 0,
      vpbreite: 0,
      vphoehe: 0,
      vpText: "",
      polsterfolie: 0,
      handfolie: 0,
      hflaenge: 0,
      hfbreite: 0,
      hfhoehe: 0,
      hfText: "",
      maschienenfolie: 0,
      mflaenge: 0,
      mfbreite: 0,
      mfhoehe: 0,
      mfText: "",
      addedPf: false,
      addedhf: false,
      addedmf: false,
    };
  },

  methods: {
    addPf() {
      let item = {
        name: "Polsterfolie",
        anzahl: this.polsterfolie,
        beschreibung: this.vpText,
        masse: {
          meter: this.vplaenge,
          breite: this.vpbreite,
          staerkemm: this.vphoehe,
        },
      };
      const store = anfragenStore();
      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedPf = true;
      setTimeout(() => {
        this.addedPf = false;
        this.polsterfolie = 0;
        this.vplaenge = 0;
        this.vpbreite = 0;
        this.vphoehe = 0;
        this.vpText = "";
      }, 2000);
    },
    addHf() {
      let item = {
        name: "Handstretchfolie",
        anzahl: this.handfolie,
        beschreibung: this.hfText,
        masse: {
          meter: this.hflaenge,
          breite: this.hfbreite,
          staerkemy: this.hfhoehe,
        },
      };
      const store = anfragenStore();
      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedhf = true;
      setTimeout(() => {
        this.addedhf = false;
        this.handfolie = 0;
        this.hflaenge = 0;
        this.hfbreite = 0;
        this.hfhoehe = 0;
        this.hfText = "";
      }, 2000);
    },
    addMf() {
      let item = {
        name: "Maschinenstretchfolie",
        anzahl: this.maschienenfolie,
        beschreibung: this.mfText,
        masse: {
          meter: this.mflaenge,
          breite: this.mfbreite,
          staerkemy: this.mfhoehe,
        },
      };
      const store = anfragenStore();
      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedmf = true;
      setTimeout(() => {
        this.addedmf = false;
        this.maschienenfolie = 0;
        this.mflaenge = 0;
        this.mfbreite = 0;
        this.mfhoehe = 0;
        this.mfText = "";
      }, 2000);
    },
  },
};
</script>
